<template>

  <div>
    <p>Activeren Teamleader integratie...</p>
    <b-spinner/>
  </div>

</template>

<script>

export default
{
    async mounted()
    {
        let redirectUri = 'https://bigfox.app/main/integration/teamleader';

        if(process.env.NODE_ENV === 'development')
            redirectUri = 'http://localhost:8080/main/integration/teamleader';
        
        await this.$apollo.mutate(
            {
                mutation: require('../graphql/mutation/redeemTlAuthzCode.gql'),
                variables:
                {
                    input:
                    {
                        code: this.$route.query.code,
                        redirectUri
                    }
                }
            }
        );

        await this.$router.push('/main/config/integrations');
    }
}


</script>

<style>
</style>